var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('router-link',{attrs:{"to":'/dialogkontrolle/' + _vm.dialogId}},[_vm._v("\n    "+_vm._s(_vm.dialogId)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }